<script lang="ts">
  import { app_user } from '../../Users/observables'
  import TopBarPage from './TopBarPage.svelte'
  import { goto } from '@roxi/routify'
  import NoAccountCta from '../NoAccountCTA.svelte'
  import VerifyEmailCta from '../VerifyEmailCta.svelte'
  import LapsedSubscriptionCta from '../LapsedSubscriptionCTA.svelte'
</script>

<TopBarPage>
  {#if $app_user.state === 'Loading'}
    <p>Loading...</p>
  {:else if $app_user.state === 'NoAccount'}
    <NoAccountCta />
  {:else if $app_user.state === 'NoSubscription'}
    <div id="sign-up-container">
      <p>
        You can't access this until you are a member of a team. Ask the team admin for an invite link or
        follow the link below to sign up another team
      </p>
      <button on:click={() => void $goto('/signup')}>Sign Up</button>
    </div>
  {:else if $app_user.state === 'UnverifiedEmail'}
    <VerifyEmailCta />
  {:else if $app_user.state === 'LapsedSubscription'}
    <LapsedSubscriptionCta />
  {:else if $app_user.state === 'Authed'}
    <slot />
  {/if}
</TopBarPage>

<style>
  #sign-up-container {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
  }

  button {
    padding: 0.5em;
  }
</style>
